import { Content, Element } from '@phrasee/phrasee-typings'

import { useAppSelector } from 'common/hooks/redux'
import useGetContentQuery from 'features/unifiedFlow/api/queries/useGetContentQuery'

import { getAllComponentElements, getAllTemplateElements } from '../helpers'

const useSelectedElement = () => {
  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )
  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )

  return useGetContentQuery(activeContentId, {
    select: (content: Content) => {
      let selectedElement: Element | undefined

      const allComponentElements = getAllComponentElements(content)

      selectedElement = allComponentElements.find(
        (element) => element.element_id === selectedElementId
      )

      if (!selectedElement) {
        const allTemplateElements = getAllTemplateElements(content)

        selectedElement = allTemplateElements.find(
          (element) => element.element_id === selectedElementId
        )
      }

      return selectedElement
    },
  })
}
export default useSelectedElement
